import { gql } from '@apollo/client';

export const GET_DASHBOARD_BATCH_REPORT_DOWNLOAD_URLS = gql`
    query DashboardReportQuery($reportIds: [Long!]!) {
        getDashboardBatchReportDownloadUrls(reportIds: $reportIds)
    }
`;

export interface GetDashboardBatchReportDownloadUrlsResponse {
    getDashboardBatchReportDownloadUrls: string[];
}

export interface GetDashboardBatchReportDownloadUrlsVariables {
    reportIds: number[];
}
